import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'

import { SearcherBaseModel } from '../../models/SearcherBaseModel'
import { IUtenteService } from '../../services/UtenteService'
import { ListUtenti } from './ListUtenti'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ai } from '../../TelemetryService'

export class PageUtentiComp extends React.Component<RouteComponentProps, any> {

    service: IUtenteService

    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.UTENTE_SERVICE)
    }

    onUtenteClick = id => {
        this.props.history.push(`Utente/Modifica/${id}`)
    }

    onUtenteNewClick = () => {
        this.props.history.push(`Utente/Modifica`)
    }

    search = async (model: SearcherBaseModel) => {
        return this.service.Search(model)
    }

    render() {
        return (
            <ListUtenti title="Utenti dei clienti" onSearch={this.search} onUtenteClick={this.onUtenteClick} onUtenteNewClick={this.onUtenteNewClick} />
        )
    }
}

export const PageUtenti = withRouter(withAITracking(ai.reactPlugin, PageUtentiComp,"PageUtenti"))
